const ShiftUnexpected = () => (
    <section id="shift-unexpected">
        <div className="container-fluid pt-2 pb-4 text-center">
            <div className="row justify-content-center align-content-center text-center py-3 gg-bg-solid-yellow-light">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-11">
                    <h1 className="fw-bold">The Shift I Didn't Expect</h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center mt-4">
                <div className="col-xl-6 col-lg-7 col-md-8 col-11 text-md-start text-center">
                    <p><b>The first day</b> after I started taking GlucoGen 7 felt... uneventful.</p>
                    <p>
                        No fireworks. No sudden surge of energy.<br />
                        Just me, going about my day, half-expecting nothing.<br />
                        But then came the second.
                    </p>
                    <p>
                        I woke up with a clarity I hadn’t felt in years.<br />
                        Not manic or jittery, just clear.<br />
                        The kind of focus I thought type 2 diabetes had stolen for good.
                    </p>
                    <p>
                        And for the first time in months, I didn’t need to lie down after breakfast.<br />
                        No crash.<br />
                        No slump.<br />
                        I felt steady, even energised, like my body was finally on my side again.
                    </p>
                    <p>
                        <b>By day five, I started noticing more.</b><br />
                        My cravings had softened.<br />
                        My blood sugar levels? Calmer. Less erratic.<br />
                        And the weight around my middle, that stubborn pouch I’d blamed on age and insulin resistance…<br />
                        Wasn’t quite so stubborn anymore.
                    </p>
                    <p className="fw-bold">Here’s what really stunned me:</p>
                    <p>
                        I didn’t feel like a type 2 diabetic controlling their disease.<br />
                        I felt like a person again.<br />
                        Living, moving, eating, thinking - without the constant buzz of fear in the background.
                    </p>
                    <p>
                        It was subtle at first, like a low hum fading into silence.<br />
                        <b>Over the weeks, the evidence stacked up.</b><br />
                        Every marker, every symptom, every metric I had once feared. Slowly, methodically, began to shift.
                    </p>
                    <p>
                        Something was changing.<br />
                        And it was only the beginning.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default ShiftUnexpected;